export const hasInputValue = (
  value: string | number | undefined | null
): boolean => {
  if (typeof value === "string") return value.length > 0;
  if (typeof value === "number") return true;
  return false;
};
